import Vue from "vue";
import Router from "vue-router";
import { store } from "../store/store";
import authGuard from "../utils/auth.guard";
import { appLogging } from "../plugins/sessionHandler";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const LoginConenedor = () => import("@/containers/Login");

// Views
const Inicio = () => import("@/views/Inicio");

// Views - Recepcion
const Ingreso = () => import("@/views/recepcion/Ingreso");
const List = () => import("@/views/recepcion/List");

// Views - Procesos
const IngresoProceso = () => import("@/views/procesos/IngresoProceso");
const IngresoProcesoyReproceso = () => import("@/views/procesos/ProcesoMain");
const IngresoRepaletizaje = () => import("@/views/procesos/IngresoRepaletizaje");
const ProcessList = () => import("@/views/procesos/List");

// const Consultas = () => import('@/views/procesos/Consultas');

// Views - Camara
const Position = () => import("@/views/camara/Position");
const StockCastana = () => import("@/views/camara/StockCastana");

// Views - Reportes
const Excel = () => import("@/views/reportes/Excel");

// Views - Despacho
const IngresoDespacho = () => import("@/views/despacho/IngresoDespacho");
const ListDespacho = () => import("@/views/despacho/List");

// Views - Materiales
const CreateSupplyWaybill = () => import("@/views/supplies/CreateSupplyWaybill");
const ListSupplies = () => import("@/views/supplies/List");
const StockSupplies = () => import("@/views/supplies/Stock");
const MappingList = () => import("@/views/supplies/MappingList");

// Views - Proforma
const CreateProforma = () => import("@/views/comercial/CreateProforma");
const ProformaList = () => import("@/views/comercial/ProformaList");

// Views - Exportacion
const InstruccionEmbarque = () => import("@/views/exportacion/InstruccionEmbarque");
const ListInstruccionEmbarque = () => import("@/views/exportacion/List");
const InspeccionEmbarque = () => import("@/views/exportacion/Inspeccion");
const ListInspecciones = () => import("@/views/exportacion/ListInspecciones");
const formAprobarPallet = () => import("@/views/exportacion/formAprobarPallet");
const ListaEmbarque = () => import("@/views/exportacion/ListaEmbarque");
const guiaDespachoExportacion = () => import("@/views/exportacion/guiaExportacion/guiaDespachoExportacion");
const ListGuiaExportacion = () => import("@/views/exportacion/guiaExportacion/ListGuiaExportacion");

//Calidad
const ListCalidad = () => import("@/views/calidad/List");
const ListProcess = () => import("@/views/calidad/ListProcess");
const DetailedLot = () => import("@/views/calidad/DetailedLotInspection");
const ReportExcel = () => import("@/views/calidad/ReportExcel");
const ListEvaluationsReception = () => import("@/views/calidad/ListEvaluationsReception");
const ListEvaluationsProcess = () => import("@/views/calidad/ListProcessEvaluationsProcess");

//Trazabilidad
const Traceability = () => import("@/views/traceability/MainTraceability.vue");
const DetailedTraceability = () => import("@/views/traceability/DetailedTraceability.vue");
const DetailedRepaletizajeProcess = () => import("@/views/traceability/DetailedRepaletizajeProcess.vue");
const DetailedWaybillReception = () => import("@/views/traceability/DetailedWaybillReception.vue");
const DetailedPalletTrazability = () => import("@/views/traceability/DetailedPalletTrazability.vue");
const DetaildedProcess = () => import("@/views/traceability/DetaildedProcess.vue");
const DetailedRepaletizajeTrazability = () => import("@/views/traceability/DetailedRepaletizaje.vue");
const detailedLote = () => import("@/views/traceability/detailedLote.vue");
const detailedWaybillDispatch = () => import("@/views/traceability/detailedWaybillDispatch.vue");
const DetailedBording = () => import("@/views/traceability/DetailedBording.vue");
const DetaildedWaybillExport = () => import("@/views/traceability/DetaildedWaybillExport.vue");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

// Bagno Views

//purchase Order
const purchaseOrderForm = () => import("@/views/purchaseOrder/Main.vue");
const purchaseOrderList = () => import("@/views/purchaseOrder/List.vue");

//Time Control
const TimeControlList = () => import("@/views/timecontrol/List.vue");

// Alfaberries Process v2
const NewV2ProcessAlfa = () => import("@/views/proceso-v2-alfa/Main.vue");

Vue.use(Router);

const routes = [
  {
    path: "",
    async beforeEnter(to, from, next) {
      if (store.state.token) {
        next();
      } else {
        await appLogging().then(() => {
          if (store.state.token) {
            next();
          } else {
            next("/pages/login");
          }
        });
      }
    },
    // redirect: "/inicio",
    name: "main",
    meta: { loginRequired: true },
    component: DefaultContainer,
    children: [
      {
        path: "/",
        name: "inicio",
        component: Inicio
      },

      // ADMIN
      {
        path: "/admin",
        // redirect: "/inicio",
        name: "admin-menu",
        meta: { label: "Admin" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/users",
            meta: { label: "Usuarios" },
            name: "admin-users",
            component: () => import("@/views/admin/Users.vue")
          }
        ]
      },

      // MODULO COMERCIAL
      {
        path: "/comercial",
        // redirect: "/inicio",
        name: "comercial-menu",
        meta: { label: "Comercial" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/mercados",
            meta: { label: "Mercados" },
            name: "comercial-mercados",
            component: () => import("@/views/comercial/Markets.vue")
          },
          {
            path: "/mercados/:id",
            meta: { label: "Crear/Editar Mercados", show: false },
            name: "comercial-mercados-edit",
            component: () => import("@/views/comercial/MarketEdit.vue")
          },
          {
            path: "/plan",
            meta: { label: "Plan comercial" },
            name: "comercial-plan",
            component: () => import("@/views/comercial/Plan.vue")
          },
          {
            path: "/plan/:id",
            meta: { label: "Plan Detalle Mercado", show: false },
            name: "comercial-plan-detail",
            component: () => import("@/views/comercial/MarketDetailPlan.vue")
          }
        ]
      },
      {
        path: "/recepcion",
        // redirect: "/inicio",
        name: "recepcion-menu",
        meta: { label: "Recepción" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/recepcion/ingreso",
            meta: { label: "Ingreso" },
            name: "recepcion-ingreso",
            component: Ingreso
          },
          {
            path: "/recepcion/listado",
            meta: { label: "Listado" },
            name: "recepcion-listado",
            component: List
          },
          {
            path: "/recepcion/lotes",
            meta: { label: "Lotes" },
            name: "recepcion-lotes",
            component: () => import("../views/recepcion/LotList")
          },
          {
            path: "/recepcion/dashboard",
            meta: { label: "Dashboard" },
            name: "recepcion-dashboard",
            component: () => import("../views/recepcion/Dashboard/DashboardMain")
          },
          {
            path: "/recepcion/editar/:waybillID",
            meta: { label: "Editar", show: false },
            name: "recepcion-editar",
            props: true,
            component: Ingreso
          }
        ]
      },
      {
        path: "/procesos",
        // redirect: "/inicio",
        name: "procesos-menu",
        meta: { label: "Procesos" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/procesos/ingreso",
            meta: { label: "Ingreso" },
            name: "procesos-ingreso",
            component: IngresoProceso
          },
          {
            path: "/procesos/3/:typeProcess",
            meta: { show: false },
            name: "procesos-ingreso-transformacion",
            props: true,
            component: () => import("@/views/procesos/ProcesoMainTransform")
          },
          {
            path: "/procesos/3/:typeProcess/editar/:processID",
            meta: { show: false },
            name: "procesos-ingreso-transformacion-editar",
            props: true,
            component: () => import("@/views/procesos/ProcesoMainTransform")
          },
          {
            path: "/procesos/1/:typeProcess",
            meta: { show: false },
            name: "procesos-ingreso-embalaje",
            props: true,
            component: IngresoProcesoyReproceso
          },
          {
            path: "/procesos/2/:typeProcess",
            meta: { show: false },
            name: "procesos-ingreso-palletizaje",
            props: true,
            component: IngresoRepaletizaje
          },
          {
            path: "/procesos/1/:typeProcess/editar/:processID",
            meta: { show: false },
            name: "procesos-ingreso-embalaje-editar",
            props: true,
            component: IngresoProcesoyReproceso
          },
          {
            path: "/procesos/listado",
            name: "process-listado",
            meta: { label: "Listado Procesos" },
            props: { process_type_option: [1, 3] },
            component: ProcessList
          },
          {
            path: "/procesos/registros/:id",
            name: "procesos-registros",
            meta: { show: false },
            props: true,
            component: NewV2ProcessAlfa
          },
          {
            path: "/procesos/dashboard",
            name: "process-dashboard",
            meta: { label: "Dashboard" },
            component: () => import("../views/procesos/Dashboard/DashboardMain")
          },
          {
            path: "/ordenes-de-pedido",
            meta: { label: "Ordenes de pedido" },
            name: "procesos-listado-orden-de-pedido",
            component: () => import("@/views/procesos/produccion/PurchaseOrderList.vue")
          },
          {
            path: "/procesos-pallet-op",
            meta: { label: "Asignar OP a pallets" },
            name: "procesos-pallet-op",
            component: () => import("@/views/procesos/produccion/ChangePalletOp.vue")
          },
          {
            path: "/crear-plan-produccion/:purchaseOrderId/:id",
            meta: { label: "Crear plan de producción", show: false },
            name: "procesos-crear-plan-produccion",
            props: true,
            component: () => import("@/views/procesos/produccion/ProductionPlan/CreateProductionPlan.vue")
          }
        ]
      },
      {
        path: "/camara",
        // redirect: "/inicio",
        name: "camara-menu",
        meta: { label: "Cámara" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/camara/stock",
            name: "camara-stock",
            meta: { label: "Stock" },
            component: () => import("../views/camara/StockMain"),
            children: [
              {
                path: "/camara/stock/:product_id",
                name: "camara-stock-producto",
                component: () => import("../views/camara/Stock2"),
                props: true
              }
            ]
          },
          {
            path: "/camara/listado-repaletizajes",
            name: "camara-listado-repaletizajes",
            meta: { label: "Listado Repaletizajes" },
            props: { process_type_option: [2] },
            component: ProcessList
          },
          {
            path: "/camara/stockonl",
            meta: { label: "Stock Onl" },
            name: "camara-stockonl",
            component: () => import("../views/camara/Stock")
          },
          {
            path: "/camara/camaras",
            meta: { label: "Cámaras" },
            name: "camara-camaras",
            component: Position
          },
          {
            path: "/camara/stock-castana",
            meta: { label: "Castaña" },
            name: "camara-stock-castana",
            component: StockCastana
          },
          {
            path: "/camara/mapeo",
            meta: { label: "Mapeo" },
            name: "camara-mapeo",
            component: MappingList
          },
          {
            path: "/camara/stock-dashboard",
            meta: { label: "Dashboard" },
            name: "camara-stock-dashboard",
            component: () => import("../views/camara/Dashboard/DashboardMain.vue")
          }
        ]
      },
      {
        path: "/posiciones",
        // redirect: "/inicio",
        name: "posiciones-menu",
        meta: { label: "Posiciones" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/posiciones/lista",
            meta: { label: "Listado" },
            name: "posiciones-listado",
            component: TimeControlList,
            props: { all_history: false }
          },
          {
            path: "/posiciones/historico",
            meta: { label: "Histórico" },
            name: "posiciones-historico",
            component: TimeControlList,
            props: { all_history: true }
          }
        ]
      },
      {
        path: "/inocuidad",
        // redirect: "/inicio",
        name: "inocuidad-menu",
        meta: { label: "Inocuidad" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/inocuidad/configuracion",
            meta: { label: "Configurar" },
            name: "inocuidad-configuracion",
            component: () => import("@/views/inocuidad/Config.vue")
          },
          {
            path: "/inocuidad/productores",
            meta: { label: "Productores" },
            name: "inocuidad-productores",
            component: () => import("@/views/inocuidad/Productores.vue")
          }
        ]
      },
      {
        path: "/materiales",
        meta: { label: "Materiales" },
        // redirect: "/inicio",
        name: "materiales-menu",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          // DREPECATED
          // {
          //   path: "/materiales/ingreso",
          //   meta: { label: "Ingreso" },
          //   name: "materiales-salida",
          //   component: CreateSupplyWaybill,
          //   props: { waybill_type: 3, edit_waybill: false } // 4 is dispatch, 3 is arrival
          // },

          {
            path: "/materiales/cuenta-corriente",
            meta: { label: "Cuentas Corrientes" },
            name: "materiales-cuenta-corriente",
            component: () => import("../views/supplies-3/CuentaCorriente.vue")
          },
          {
            path: "/materiales/subir-stock",
            meta: { label: "Subir Stock" },
            name: "materiales-subir-stock",
            component: () => import("../views/supplies-3/UploadStock.vue")
          },
          {
            path: "/materiales/ingreso/",
            meta: { label: "Ingreso" },
            name: "materiales-ingreso",
            props: { waybill_type: "ingreso" },
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/movimiento/",
            meta: { label: "Movimiento interno" },
            name: "materiales-movimiento",
            props: { waybill_type: "ingreso" },
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/movimiento/:id",
            meta: { label: "Movimiento interno", show: false },
            name: "materiales-editar-movimiento",
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/despacho/",
            meta: { label: "Despacho" },
            props: { waybill_type: "despacho" },
            name: "materiales-despacho",
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/ingreso/:id",
            meta: { label: "Ingreso", show: false },
            name: "materiales-editar-ingreso",
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/despacho/:id",
            meta: { label: "Despacho", show: false },
            name: "materiales-editar-despacho",
            component: () => import("../views/supplies-3/Ingreso")
          },
          {
            path: "/materiales/lista",
            meta: { label: "Listado" },
            name: "materiales-listado",
            component: ListSupplies
          },
          {
            path: "/materiales/stock",
            name: "materiales-stock",
            meta: { label: "Stock" },
            component: StockSupplies
          },
          {
            path: "/materiales/editar/:waybill_type/:waybillID",
            meta: { label: "Histórico", show: false },
            name: "materiales-editar",
            props: true,
            component: CreateSupplyWaybill
            // props: { edit_waybill: true } // 1 is dispatch, 0 is arrival
          }
        ]
      },
      {
        path: "/despacho",
        // redirect: "/inicio",
        name: "despacho-menu",
        meta: { label: "Despacho" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/despacho/traslado",
            name: "despacho-traslado",
            meta: { label: "Traslado" },
            component: () => import("@/views/despacho/traslado/Main")
          },
          {
            path: "/despacho/traslado-interplanta",
            name: "despacho-traslado-interplanta",
            meta: { label: "Traslado Interplanta" },
            component: () => import("@/views/despacho/trasladoInterplanta/Main")
          },
          {
            path: "/despacho/ingreso",
            name: "despacho-ingreso",
            meta: { label: "Ingreso" },
            component: IngresoDespacho
          },
          {
            path: "/despacho/listado",
            name: "despacho-listado",
            meta: { label: "Listado" },
            component: ListDespacho
          },
          {
            path: "/despacho/editar/:waybillID",
            name: "despacho-editar",
            meta: { label: "Editar", show: false },
            props: true,
            component: IngresoDespacho
          }
        ]
      },
      {
        path: "/exportaciones",
        name: "exportaciones-menu",
        meta: { label: "Exportaciones" },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/exportaciones/instructivo",
            meta: { label: "Ingreso Instructivo" },
            name: "exportaciones-instructivo",
            component: InstruccionEmbarque
          },
          {
            path: "/exportaciones/listado",
            meta: { label: "Listado Embarques" },
            name: "exportaciones-listado-embarques",
            component: ListInstruccionEmbarque
          },
          {
            path: "/exportaciones/instructivo/editar/:BoardingID",
            meta: { label: "Listado", show: false },
            name: "exportaciones-instructivo-editar",
            props: true,
            component: InstruccionEmbarque
          },
          {
            path: "/exportaciones/inspeccion",
            meta: { label: "Ingreso Inspección" },
            name: "exportaciones-inspeccion",
            props: true,
            component: InspeccionEmbarque
          },
          {
            path: "/exportaciones/lista-inspeccion",
            meta: { label: "Listado Inspecciones" },
            name: "exportaciones-listado-inspeccion",
            props: true,
            component: ListInspecciones
          },
          {
            path: "/exportaciones/aprobar-inspeccion/:idInspection",
            name: "exportaciones-aprobar-inspeccion",
            meta: { show: false },
            props: true,
            component: formAprobarPallet
          },
          {
            path: "/exportaciones/packing-list",
            name: "exportaciones-packing-list",
            meta: { label: "Ingreso Packing List" },
            props: true,
            component: ListaEmbarque
          },
          {
            path: "/exportaciones/despacho-guia-exportacion",
            name: "exportaciones-despacho-guia-exportacion",
            meta: { label: "Ingreso Despacho" },
            props: true,
            component: guiaDespachoExportacion
          },
          {
            path: "/exportaciones/listado-guias",
            name: "exportaciones-listado-guias",
            meta: { label: "Listado Guías Exportación" },
            props: true,
            component: ListGuiaExportacion
          },
          {
            path: "/exportaciones/editar-guia-exportacion/:ExportGuiaID",
            name: "exportaciones-editar-guia-exportacion",
            meta: { show: false },
            props: true,
            component: guiaDespachoExportacion
          }
        ]
      },
      {
        path: "/datos",
        name: "descargar-datos",
        component: Excel
      },
      {
        path: "/proformas",
        meta: { label: "Proforma" },
        name: "proforma-menu",

        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/proformas/ingreso",
            meta: { label: "Ingreso" },
            name: "proforma-ingreso",
            component: CreateProforma
          },
          {
            path: "/proformas/listado",
            meta: { label: "Listado" },
            name: "proforma-listado",
            component: ProformaList
          },
          {
            path: "/proformas/alfaberries/listado",
            meta: { label: "Listado" },
            name: "proforma-listado-alfaberries",
            component: () => import("@/views/custom_views/alfaberries/ProformaList")
          }
        ]
      },
      {
        path: "/calidad",
        meta: { label: "Calidad" },
        name: "calidad-menu",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/calidad/listado-recepcion",
            meta: { label: "Listado recepción" },
            name: "calidad-listado-recepcion",
            component: ListCalidad
          },
          {
            path: "/calidad/listado-proceso",
            meta: { label: "Listado proceso" },
            name: "calidad-listado-proceso",
            component: ListProcess
          },
          {
            path: "/calidad/asignar-clasificacion-por-pallet",
            meta: { label: "Asignar clasificación por pallet" },
            name: "calidad-asignar-clasificacion-por-pallet",
            component: () => import("@/views/calidad/ChangePalletStatus")
          },
          {
            path: "/calidad/datos",
            meta: { label: "Datos" },
            name: "calidad-datos",
            component: ReportExcel
          },
          {
            path: "/calidad/detailed-lot-inspection/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id/:index",
            meta: { show: false },
            name: "calidad-detailed-lot-inspection",
            props: true,
            component: DetailedLot
          },
          {
            path: "/calidad/detailed-evaluations-lot/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id",
            meta: { show: false },
            name: "calidad-detailed-evaluations-lot",
            props: true,
            component: ListEvaluationsReception
          },
          {
            path: "/calidad/detailed-evaluations-lot-process/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id",
            meta: { show: false },
            name: "calidad-detailed-evaluations-lot-process",
            props: true,
            component: ListEvaluationsProcess
          }
        ]
      },
      {
        path: "/historico",
        name: "historico",
        meta: { show: false },
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/historico/inicio",
            name: "historico-inicio",
            component: () => import("@/views/historico/Main")
          },
          {
            path: "/historico/buscar",
            name: "historico-buscar",
            component: () => import("@/views/historico/BuscarHistorico")
          }
        ]
      },
      {
        path: "/trazabilidad",
        meta: { show: false },
        name: "trazabilidad",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "search",
            name: "trazabilidad-buscar",
            component: Traceability
          },
          {
            path: "detailed/:PalletID/:ContentID/:PalletNumber",
            name: "trazabilidad-detalle",
            props: true,
            component: DetailedTraceability
          },
          {
            path: "process-repaletting/:PalletID/:ContentID/:PalletNumber",
            name: "trazabilidad-pallet-repaletizado",
            props: true,
            component: DetailedRepaletizajeProcess
          },
          {
            path: "detailed-waybill-reception/:waybill_id/:numGuia",
            name: "trazabilidad-detalle-guia-recepcion",
            props: true,
            component: DetailedWaybillReception
          },
          {
            path: "detailed-pallet-trazability/:PalletID/:NumeroPallet",
            name: "trazabilidad-detalle-pallet",
            props: true,
            component: DetailedPalletTrazability
          },
          {
            path: "detailed-process/:process_id/:numProcess",
            name: "trazabilidad-detalle-proceso",
            props: true,
            component: DetaildedProcess
          },
          {
            path: "detailed-repaletizaje/:process_id/:numProcess",
            name: "trazabilidad-detalle-repaletizaje",
            props: true,
            component: DetailedRepaletizajeTrazability
          },
          {
            path: "detailed-lote/:waybill_id/:numLote",
            name: "trazabilidad-detalle-lote",
            props: true,
            component: detailedLote
          },
          {
            path: "detailed-waybill-dispatch/:waybill_id/:numGuia",
            name: "trazabilidad-detalle-guia-despacho",
            props: true,
            component: detailedWaybillDispatch
          },
          {
            path: "detailed-bording/:bording_id/:bording_number",
            name: "trazabilidad-detalle-embarque",
            props: true,
            component: DetailedBording
          },
          {
            path: "detailed-waybill-export/:waybill_id/:numWaybill",
            name: "trazabilidad-detalle-guia-exportacion",
            props: true,
            component: DetaildedWaybillExport
          }
        ]
      },
      {
        path: "/orden-de-compra",
        meta: { label: "OC" },
        name: "oc-menu",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/orden-de-compra/ingreso",
            meta: { label: "Ingreso" },
            name: "oc-ingreso",
            component: purchaseOrderForm
          },
          {
            path: "/orden-de-compra/lista-orden-compra",
            meta: { label: "Listado" },
            name: "oc-listado",
            component: purchaseOrderList
          }
        ]
      }
    ]
  },
  {
    path: "/pages",
    redirect: "/pages/login",
    name: "Pages",
    component: LoginConenedor,
    children: [
      {
        path: "404",
        name: "not-found",
        component: Page404
      },
      {
        path: "500",
        name: "Page500",
        component: Page500
      },
      {
        path: "/503",
        name: "unauthorized",
        component: () => import("@/views/pages/Page503.vue")
      },
      {
        path: "login",
        name: "Login",
        component: Login
      },
      {
        path: "register",
        name: "Register",
        component: Register
      }
    ]
  }
];

const router = new Router({
  linkActiveClass: "active",
  routes
  // mode: 'history'
});
router.beforeEach(authGuard);
export default router;
